<template>
  <div class="pa-3">
    <v-snackbar top right v-model="snackbar" :color="snackbar_color" :timeout="2000" >
      <span>{{$t(page+'.'+message)}}</span>
    </v-snackbar>
    <v-card class="neu-glow mt-5 mb-2">
      <v-row class="d-flex justify-center px-6">
        <v-col class="px-0" v-for="(avg,avgi) in [{name:'Canoni',code:'lease',value:64},{name:'WhatsApp',code:'whatsapp',value:26},{name:'Forwarding',code:'forward',value:4},{name:'Text To Speech',code:'TTS',value:6}]" :key=avgi>
          <v-card class="neu-glow pa-4 mx-2">
            <v-row>
              <v-col class="text-center">
                  <v-progress-circular
                    v-bind="attrs"
                    v-on="on"
                    :rotate="270"
                    :size="wWidth/10"
                    :width="wWidth/80"
                    :value="avg.value"
                    color="info"
                  >
                    {{avg.value}}
                  </v-progress-circular>                
              </v-col>
              <v-col cols="12" class="text-h5 text-center">{{avg.name}}</v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row> 
      <v-row class="ma-0" style="width:100%">
        <v-col md="12" cols="12">
          <v-data-table
            dense
            fixed-header
            :headers="headers"
            :items="!items?[]:items"
            hide-default-footer
            :items-per-page=500
            :item-class="itemClass"
            :loading="loading"
            no-data-text="Nessun dato presente in archivio"
            no-results-text="Nessun Risultato estratto"
            loading-text="Consultazione archivio: attendi..."
          >
            <template v-slot:[`item.docDate`]="{ item }">
              <div>
                {{new Intl.DateTimeFormat(user.location, { day:'2-digit',month:'2-digit',year:'numeric' }).format(new Date(item.docDate))}}
              </div>
            </template>
            <template v-slot:[`item.active`]="{ item }">
              <v-simple-checkbox
                v-model="item.active"
                color="success"
                disabled
              ></v-simple-checkbox>
            </template>                
            <template v-slot:[`item.actions`]="{ item }">
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn v-bind="attrs" v-on="on" icon class="mr-2" @click.stop="printItem(item)">
                      <v-icon color="info">mdi-printer</v-icon>
                    </v-btn>
                  </template>
                  <span>Stampa</span>
                </v-tooltip>
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn v-bind="attrs" v-on="on" icon @click.stop="payItem(item)">
                      <v-icon :color="item.paidOn?'success':'info'">mdi-cash</v-icon>
                    </v-btn>
                  </template>
                  <span>{{item.paidOn?'Pagata':'Paga'}}</span>
                </v-tooltip>  
            </template>                
          </v-data-table>          
        </v-col>
      </v-row>
    </v-card>
    <v-dialog v-model="dialog_printItem" 
        max-width="900"
        v-if="printableItem"
      >
        <v-card>
          <v-card-title>
            Fattura
            <v-spacer></v-spacer>
            <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-2"  @click="dialog_printItem = false">
                    <v-icon color="info">mdi-close</v-icon>
                </v-btn>
                </template>
                <span>Esci</span>
            </v-tooltip>               
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <v-col cols="12"> 
              <v-card>
                <iframe id="printIframe" :src="printableItem.PDFURL" width="100%" :height="(wHeight-200)+'px'"></iframe>
              </v-card>
            </v-col> 
          </v-card-text>
        </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
//import { availableCountries  } from "@/config/countries";
//import _ from 'lodash'

export default {
  data() {
    return {
      page: "Account",
      wHeight: window.innerHeight,
      wWidth: window.innerWidth,
      form: this.$store.state.userdata.user,
      dialog_printItem:false,
      printableItem:null,
      snackbar: false,     
      message:'',
      loading:false,

      snackbar_color:'success', 
      closedDays:null,
      dialog_closedDayException:false,
      items:[{date:'12-08-2022',number:'147',amount:'119.99',paidOn:"12-08-2022"}],
      headers: [
          { text: 'Data',      value: 'docDate',      align: 'center',  sortable: false, class:'px-1 text-lg-button' },
          { text: 'Numero',    value: 'docNumber',    align: 'center',  sortable: false, class:'px-1 text-lg-button' },
          { text: 'Importo',   value: 'amount',       align: 'center',  sortable: false, class:'px-1 text-lg-button' },
          { text: 'Pagata il', value: 'paymentDate',  align: 'center',  sortable: false, class:'px-1 text-lg-button' },
          { text: 'Azione',    value: 'actions',      align: 'center',  sortable: false, class:'px-1 text-lg-button' },
      ]  
    };
  },
  computed : {
    ...mapGetters(["settings"]),
  },
  beforeUnmount()
  {
      alert("leaving")
  },
  created(){
    this.getData()

    //console.log(716,this.user);
    /*
    if (this.user&&this.user.username=='')
    {
      this.$router.push('/auth/login').catch(() => {});
    }
    else
    {
      this.getData()
    }*/
  },
  mounted(){
    //console.log(768,this.$route.query.user)
  },
  watch : {

  },
  methods:
  {
    printItem(f)
    {
      console.log(168,f)
      this.printableItem=f;
      this.dialog_printItem=true;
    },
    async payItem(f)
    {
        console.log(144,f,this.editedItem);
        this.loading_update=true;
        var action='payItem';
        let payload={"action":action,"payload":JSON.stringify(this.editedItem)};
        console.log(257,payload)
        let w= await this.updateDB(payload)
        this.loading_update=false;
        console.log(260,w);
        if(w.errorid=='0')
        {
            this.snackbar_color="success"
            this.message =w.message;
            this.snackbar = true;
            this.dialog_editItem=false;
            //this.slotsByDOW_hash=JSON.stringify(this.slotsByDOW);
        }   
    },
    async getData(origin)
    {
        {
            console.log(origin);
            this.loading=true;
            try{
                const payload=JSON.stringify({"date": this.date,"action":"AllInvoices_get"});
                const res = await this.$http.post('/settings/settings.php', payload );
                console.log(275,res);
                this.loading=false;
                switch (res.data.errorid)
                {
                case '0':
                    sessionStorage.setItem('jwt', res.data.jwt);
                    this.items=res.data.payloads.allInvoices;
                    console.log(315,this.items)
                break;
                case '0006':
                    this.$router.push('/auth/login').catch(() => {});
                break;
                }
                this.loading= false;
            } catch(e)
            {
                this.loading= false;
                //console.log(res.data);
            }
        }
    },
    async updateDB(payload){
        try{
            const res = await this.$http.post('/settings/settings.php', payload);
            console.log(324,res);
            if (res.data.errorid=='0')
            {
            sessionStorage.setItem('jwt', res.data.jwt);
            this.snackbar_color='success';
            this.snackbar_message=res.data.message;

            if (res.data.message)
            {
                console.log(333);
                //this.snackbar=true;
            }
            }
            else
            {
              this.snackbar_color='error'
              this.snackbar_message=res.data.message;
              this.snackbar=true;
            console.log(342);
            //this.$router.push('/auth/login').catch(() => {});
            }

            //this.$store.dispatch("setUser", res.data.user); 
            return res.data;
        } catch(e)
        {
        console.log(e);
        }
    },
  },
};
</script>